/* ============================================================
   Kawish by JB — Shopify Ajax Cart Controller
   Handles live Shopify Ajax Cart API calls (/cart.js, /cart/add.js, /cart/change.js)
   ============================================================ */

'use strict';

window.KawishCart = (function () {
  const drawer         = document.getElementById('cart-drawer');
  const overlay        = document.getElementById('cart-drawer-overlay');
  const closeBtn       = document.getElementById('cart-drawer-close');
  const cartBtn        = document.getElementById('cart-btn');
  const itemsContainer = document.getElementById('cart-drawer-items');
  const emptyState     = document.getElementById('cart-drawer-empty');
  const drawerCount    = document.getElementById('cart-drawer-count');
  const subtotalEl     = document.getElementById('cart-subtotal');
  const cartCounts     = document.querySelectorAll('.cart-count');
  const shippingText   = document.getElementById('shipping-bar-text');
  const shippingFill   = document.getElementById('shipping-bar-fill');

  const FREE_SHIPPING_THRESHOLD = (window.KawishThemeSettings && window.KawishThemeSettings.freeShippingThreshold) || 3000;

  function openCart() {
    if (drawer && overlay) {
      drawer.classList.add('open');
      overlay.classList.add('open');
      drawer.setAttribute('aria-hidden', 'false');
      overlay.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
  }

  function closeCart() {
    if (drawer && overlay) {
      drawer.classList.remove('open');
      overlay.classList.remove('open');
      drawer.setAttribute('aria-hidden', 'true');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
  }

  function formatMoney(cents) {
    if (window.Shopify && Shopify.formatMoney) {
      return Shopify.formatMoney(cents);
    }
    const amount = (cents / 100).toFixed(0);
    return 'Rs. ' + parseInt(amount).toLocaleString('en-PK');
  }

  async function fetchCart() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      renderCart(cart);
    } catch (e) {
      console.error('Error fetching cart:', e);
    }
  }

  function renderCart(cart) {
    const totalItems = cart.item_count || 0;
    const subtotal = cart.total_price || 0;

    cartCounts.forEach(el => { el.textContent = totalItems; });
    if (drawerCount) drawerCount.textContent = totalItems;
    if (cartBtn) {
      cartBtn.setAttribute('aria-label', `Shopping cart, ${totalItems} item${totalItems !== 1 ? 's' : ''}`);
    }

    if (subtotalEl) {
      subtotalEl.textContent = formatMoney(subtotal);
    }

    if (shippingText && shippingFill) {
      const thresholdCents = FREE_SHIPPING_THRESHOLD * 100;
      if (subtotal >= thresholdCents) {
        shippingText.textContent = '✦ You qualify for FREE Shipping!';
        shippingFill.style.width = '100%';
      } else {
        const remaining = thresholdCents - subtotal;
        const pct = Math.min(100, Math.round((subtotal / thresholdCents) * 100));
        shippingText.textContent = `Add ${formatMoney(remaining)} more to unlock FREE Shipping!`;
        shippingFill.style.width = `${pct}%`;
      }
    }

    if (totalItems === 0) {
      if (itemsContainer) itemsContainer.style.display = 'none';
      if (emptyState) emptyState.style.display = 'flex';
    } else {
      if (itemsContainer) itemsContainer.style.display = 'flex';
      if (emptyState) emptyState.style.display = 'none';
    }

    if (itemsContainer && cart.items) {
      itemsContainer.innerHTML = cart.items.map((item, idx) => `
        <div class="cart-item" data-key="${item.key}" data-line="${idx + 1}">
          <div class="cart-item-img-wrap">
            <img src="${item.image || ''}" alt="${item.product_title}" class="cart-item-img" width="72" height="72" />
          </div>
          <div class="cart-item-details">
            <h4 class="cart-item-title">${item.product_title}</h4>
            ${item.variant_title ? `<span class="cart-item-variant">${item.variant_title}</span>` : ''}
            <span class="cart-item-price">${formatMoney(item.final_line_price)}</span>
            <div class="cart-item-qty">
              <button class="qty-btn qty-minus" aria-label="Decrease quantity" data-key="${item.key}" data-qty="${item.quantity - 1}">-</button>
              <span class="qty-val">${item.quantity}</span>
              <button class="qty-btn qty-plus" aria-label="Increase quantity" data-key="${item.key}" data-qty="${item.quantity + 1}">+</button>
            </div>
          </div>
          <button class="cart-item-remove" aria-label="Remove ${item.product_title}" data-key="${item.key}">✕</button>
        </div>
      `).join('');

      itemsContainer.querySelectorAll('.qty-btn').forEach(btn => {
        btn.addEventListener('click', () => {
          changeItem(btn.dataset.key, parseInt(btn.dataset.qty));
        });
      });

      itemsContainer.querySelectorAll('.cart-item-remove').forEach(btn => {
        btn.addEventListener('click', () => {
          changeItem(btn.dataset.key, 0);
        });
      });
    }
  }

  async function addItem(id, quantity = 1) {
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: id, quantity: quantity })
      });
      const data = await res.json();
      await fetchCart();
      openCart();
      return data;
    } catch (e) {
      console.error('Error adding to cart:', e);
    }
  }

  async function changeItem(key, quantity) {
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      });
      const cart = await res.json();
      renderCart(cart);
    } catch (e) {
      console.error('Error updating cart:', e);
    }
  }

  // Quick add handlers
  document.addEventListener('click', (e) => {
    const quickAddBtn = e.target.closest('.product-quick-add');
    if (quickAddBtn && quickAddBtn.dataset.variantId) {
      e.preventDefault();
      addItem(quickAddBtn.dataset.variantId, 1);
    }
  });

  if (cartBtn) cartBtn.addEventListener('click', openCart);
  if (closeBtn) closeBtn.addEventListener('click', closeCart);
  if (overlay) overlay.addEventListener('click', closeCart);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeCart();
  });

  fetchCart();

  return {
    open: openCart,
    close: closeCart,
    add: addItem,
    fetch: fetchCart
  };
})();
